export default __webpack_public_path__ + "static/dismoi-screenshot-selon-que-choisir-mounted-website-mobile-3a134beb27732059d7bc69802bb9ef6f.jpg";